class ContratoService
  @$inject = [ 'genericServiceHelper', 'httpService', 'pathService' ]

  constructor: (serviceHelper, @httpService, @pathService) ->

    serviceHelper(
      url: '/eficiencia-fiscal/contrato/'
      screenId: '#eficiencia-fiscal'
      service: this
      callFunctionConfig:
        method: "PUT",
        holder: "function"
      callFunctions: [
        {name: 'gerarBoleto', args: [ 'gerar_boleto' ]}
        {name: 'alterarStatus', args: [ 'alterar_status' ]}
      ]
    )
    

  checkExistence: (cnpj, callback) ->
    url = @pathService.parametrize('/api/empresas/check-existence', cnpj: cnpj)

    @httpService.request(url: url, method: "GET", onSuccess: callback)

angular.module('eficienciaFiscalModule').service('contratoService', ContratoService)
